import { useState } from 'react';
import { Link } from 'react-router-dom';
import imgRealEstate from '../assets/images/interior-living.jpg';

const SERVICES = [
  { num: '01', title: 'Définition du profil', desc: "Budget, objectif (rendement / patrimoine / usage mixte), horizon d'investissement" },
  { num: '02', title: 'Choix de la ville et du quartier', desc: 'Analyse de votre profil vs les marchés disponibles' },
  { num: '03', title: 'Mise en relation', desc: 'Agents immobiliers, avocats, experts-comptables, sociétés de gestion locative — tous francophones ou anglophones' },
  { num: '04', title: 'Suivi du dossier', desc: "De la recherche du bien jusqu'à la signature et la mise en location" },
];

const STEPS = [
  { step: '1', title: 'Remplissez le formulaire', desc: 'Décrivez votre projet en quelques lignes' },
  { step: '2', title: 'Premier appel (30 min)', desc: 'Échange gratuit pour comprendre votre projet' },
  { step: '3', title: "Plan d'action personnalisé", desc: 'Villes, typologies, budget, partenaires recommandés' },
];

const PROJECT_TYPES = ['Investissement locatif classique', 'Airbnb / Saisonnier', 'Résidence secondaire', 'Aliyah / Installation', 'Autre'];

const ORIGINS = ['France', 'Belgique', 'Suisse', 'Canada', 'Maroc', 'Diaspora'];

export default function Accompagnement() {
  const [form, setForm] = useState({ name: '', email: '', phone: '', projectType: '', message: '' });
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleChange = e => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const res = await fetch('https://formspree.io/f/xwvrdvdr', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(form),
      });
      if (res.ok) {
        setSubmitted(true);
      } else {
        alert('Une erreur est survenue. Merci de réessayer ou d\'écrire à contact@deal-israel.com');
      }
    } catch {
      alert('Une erreur est survenue. Merci de réessayer ou d\'écrire à contact@deal-israel.com');
    } finally {
      setSubmitting(false);
    }
  };

  const blockStyle = {
    background: 'var(--color-bg-white)',
    borderRadius: 'var(--radius-lg)',
    padding: '2rem 2.25rem',
    border: '1px solid var(--color-border)',
    marginBottom: '2rem',
  };

  return (
    <div className="page-content">
      <div className="container" style={{ maxWidth: 900 }}>

        {/* Hero section */}
        <div style={{ background: '#0d1f3c', backgroundImage: `linear-gradient(135deg, rgba(13,31,60,0.82) 0%, rgba(26,58,108,0.82) 100%), url(${imgRealEstate})`, backgroundSize: 'cover', backgroundPosition: 'center', borderRadius: 'var(--radius-xl)', padding: '3.5rem 2.5rem', color: '#fafaf8', marginBottom: '3rem', textAlign: 'center' }}>
          <span className="gold-tag">Service</span>
          <h1 style={{ color: '#fafaf8', marginBottom: '1rem', marginTop: '0.5rem' }}>Trouvons votre deal ensemble</h1>
          <p style={{ color: 'rgba(250,250,248,0.78)', fontSize: '1.05rem', maxWidth: 580, margin: '0 auto', lineHeight: 1.7 }}>
            Décrivez votre projet en quelques lignes. Nous analysons votre profil et vous orientons vers les meilleures opportunités du marché israélien.
          </p>
        </div>

        {/* Pour qui */}
        <div style={blockStyle}>
          <h2>Pour qui ?</h2>
          <p style={{ lineHeight: 1.8 }}>
            Ce service s'adresse aux <strong>francophones</strong> (France, Belgique, Suisse, Canada, Maroc…) qui souhaitent investir en Israël mais ne savent pas par où commencer : barrière linguistique, méconnaissance du marché local, complexité administrative.
          </p>
          <div style={{ display: 'flex', gap: '0.625rem', flexWrap: 'wrap', marginTop: '1.25rem' }}>
            {ORIGINS.map(f => (
              <span key={f} className="badge badge-blue" style={{ fontSize: '0.82rem', padding: '5px 14px' }}>{f}</span>
            ))}
          </div>
        </div>

        {/* Ce que nous proposons */}
        <div style={blockStyle}>
          <h2>Ce que nous proposons</h2>
          <div className="grid-2" style={{ marginTop: '1.75rem' }}>
            {SERVICES.map((s, i) => (
              <div key={i} style={{ display: 'flex', gap: '1.25rem', alignItems: 'flex-start' }}>
                <span style={{ fontFamily: 'var(--font-display)', fontSize: '1.1rem', fontWeight: 700, color: 'var(--color-accent)', flexShrink: 0, minWidth: 28, paddingTop: 2, letterSpacing: '0.04em' }}>{s.num}</span>
                <div>
                  <strong style={{ color: 'var(--color-primary)', fontSize: '0.95rem' }}>{s.title}</strong>
                  <p style={{ margin: '0.3rem 0 0', fontSize: '0.875rem', lineHeight: 1.6 }}>{s.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Comment ça marche */}
        <div style={blockStyle}>
          <h2>Comment ça marche ?</h2>
          <div style={{ display: 'flex', gap: '1.5rem', marginTop: '1.75rem', flexWrap: 'wrap' }}>
            {STEPS.map((s, i) => (
              <div key={i} style={{ flex: 1, minWidth: 200, textAlign: 'center' }}>
                <div style={{ width: 44, height: 44, borderRadius: '50%', background: 'var(--color-primary)', color: '#fafaf8', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'var(--font-display)', fontSize: '1.1rem', fontWeight: 700, margin: '0 auto 1rem' }}>
                  {s.step}
                </div>
                <strong style={{ color: 'var(--color-primary)', fontSize: '0.95rem' }}>{s.title}</strong>
                <p style={{ margin: '0.3rem 0 0', fontSize: '0.85rem', lineHeight: 1.6 }}>{s.desc}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Formulaire */}
        <div style={blockStyle}>
          <h2>Parlez-nous de votre projet</h2>
          {submitted ? (
            <div style={{ background: 'rgba(20,83,45,0.08)', border: '1px solid #14532d', borderRadius: 'var(--radius-lg)', padding: '2rem', textAlign: 'center', marginTop: '1.5rem' }}>
              <div style={{ width: 40, height: 40, borderRadius: '50%', background: '#14532d', color: '#fafaf8', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 1rem', fontSize: '1.1rem', fontWeight: 700 }}>✓</div>
              <h3 style={{ color: '#14532d' }}>Merci pour votre message</h3>
              <p style={{ color: '#14532d', margin: 0 }}>Nous reviendrons vers vous sous 24–48h pour un premier échange.</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} style={{ marginTop: '1.5rem' }}>
              <div className="grid-2">
                <div className="form-group">
                  <label className="form-label">Nom et prénom *</label>
                  <input className="form-input" name="name" value={form.name} onChange={handleChange} placeholder="Jean Dupont" required />
                </div>
                <div className="form-group">
                  <label className="form-label">Email *</label>
                  <input className="form-input" type="email" name="email" value={form.email} onChange={handleChange} placeholder="jean@example.com" required />
                </div>
              </div>
              <div className="grid-2">
                <div className="form-group">
                  <label className="form-label">Téléphone / WhatsApp</label>
                  <input className="form-input" name="phone" value={form.phone} onChange={handleChange} placeholder="+33 6 12 34 56 78" />
                </div>
                <div className="form-group">
                  <label className="form-label">Type de projet</label>
                  <select className="form-select" name="projectType" value={form.projectType} onChange={handleChange}>
                    <option value="">-- Choisir --</option>
                    {PROJECT_TYPES.map(t => <option key={t} value={t}>{t}</option>)}
                  </select>
                </div>
              </div>
              <div className="form-group">
                <label className="form-label">Décrivez votre projet (budget, ville cible, horizon…)</label>
                <textarea className="form-textarea" name="message" value={form.message} onChange={handleChange} placeholder="Ex : Je cherche un appartement 2 pièces autour de 500 000 € à Netanya ou Haïfa pour de la location longue durée. Horizon 10 ans." />
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '1rem' }}>
                <p style={{ fontSize: '0.8rem', color: 'var(--color-text-muted)', margin: 0 }}>
                  Vos données ne sont pas partagées avec des tiers.
                </p>
                <button type="submit" className="btn btn-primary btn-lg" disabled={submitting}>
                  {submitting ? 'Envoi en cours…' : 'Envoyer ma demande'}
                </button>
              </div>
            </form>
          )}
        </div>

        {/* Liens rapides */}
        <div style={{ textAlign: 'center', padding: '1rem 0 2rem' }}>
          <p style={{ marginBottom: '1.25rem' }}>En attendant, explorez :</p>
          <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link to="/villes" className="btn btn-outline">Comparer les villes</Link>
            <Link to="/simulateurs" className="btn btn-outline">Simuler un rendement</Link>
            <Link to="/strategies" className="btn btn-outline">Voir les stratégies</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
